"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "camporosso": {
    "eea6c879": [{
      "hkey": "4f75e1d3",
      "slug": "balloi-trinita",
      "name": "Balloi-Trinità",
      "primary": true,
      "skipSearch": false
    }],
    "balloi": [{
      "hkey": "4f75e1d3",
      "slug": "balloi-trinita",
      "name": "Balloi-Trinità",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "57a2e434": [{
      "hkey": "598ff0cf",
      "slug": "ciaixe-maguada",
      "name": "Ciaixe-Maguada",
      "primary": true,
      "skipSearch": false
    }],
    "ciaixe": [{
      "hkey": "598ff0cf",
      "slug": "ciaixe-maguada",
      "name": "Ciaixe-Maguada",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "50fb23fa": [{
      "hkey": "4f75e1d3",
      "slug": "balloi-trinita",
      "name": "Balloi-Trinità",
      "primary": true,
      "skipSearch": false
    }],
    "trinita": [{
      "hkey": "4f75e1d3",
      "slug": "balloi-trinita",
      "name": "Balloi-Trinità",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "camporosso"
    }],
    "c5fd20a7": [{
      "hkey": "599e7590",
      "slug": "camporosso",
      "name": "Camporosso",
      "primary": true,
      "skipSearch": false
    }],
    "fontane": [{
      "hkey": "599e7590",
      "slug": "camporosso",
      "name": "Camporosso",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "a6344721": [{
      "hkey": "599e7590",
      "slug": "camporosso",
      "name": "Camporosso",
      "primary": true,
      "skipSearch": false
    }],
    "martinazzi": [{
      "hkey": "599e7590",
      "slug": "camporosso",
      "name": "Camporosso",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;